export const GET_WARBOX_CONVERSATION = 'GET_WARBOX_CONVERSATION';
export const GET_WARBOX_CONVERSATIONS = 'GET_WARBOX_CONVERSATIONS';
export const UPSERT_WARBOX_CONVERSATION = 'UPSERT_WARBOX_CONVERSATION';
export const UPDATE_WARBOX_CONVERSATION = 'UPDATE_WARBOX_CONVERSATION';
export const DELETE_WARBOX_CONVERSATION = 'DELETE_WARBOX_CONVERSATION';
